import { useContext } from 'react';
import Modal from '@/common/Modal';
import ModalContext from '~/context/vdp/ModalContext';
import { CleanVehicleTaxPill } from './EvTaxModal.styles';
import {
  AdditionalRequirements,
  CleanVehicleTaxSavings,
  IncomeRequirements,
  VehicleRequirements
} from './ModalSections';

export default function EVCreditModal() {
  const { isEvTaxCreditModalOpen, setEvTaxCreditModalOpen } =
    useContext(ModalContext);

  return (
    <Modal
      open={isEvTaxCreditModalOpen}
      headerText="Clean Vehicle Tax Credit"
      onToggle={() => setEvTaxCreditModalOpen(false)}
      whiteBg
    >
      <div className="flex flex-col gap-16 px-24 py-24 m:px-[140px] m:py-40">
        <CleanVehicleTaxPill>Clean Vehicle Tax Credit</CleanVehicleTaxPill>
        <CleanVehicleTaxSavings />
        <IncomeRequirements />
        <AdditionalRequirements />
        <VehicleRequirements />
      </div>
    </Modal>
  );
}
